import types from "./types";
import globalTypes from "../../../store/types";

// Avoid importing the store at module load to prevent circular init issues
const getDispatch = () =>
  import("../../../store/index").then((mod) => mod.store.dispatch);

export const setRegisterEmail = (email) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_REGISTER_EMAIL, payload: email });
  });
};

export const setUserLoggedIn = (status) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_LOGGED_IN, payload: status });
  });
};

export const setAdminLoggedIn = (status) => {
  return getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_ADMIN_LOGGED_IN, payload: status });
  });
};

export const setUserDetails = (details) => {
  return getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_USER_DETAILS, payload: details });
  });
};

export const setUserLocation = (location) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_LOCATION, payload: location });
  });
};

export const setPartnerStatus = (status) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_HAS_PARTNER, payload: status });
  });
};

export const setChildrenStatus = (status) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_HAS_CHILDREN, payload: status });
  });
};

export const setOtherChildrenStatus = (status) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_HAS_OTHER_CHILDREN, payload: status });
  });
};

export const logout = () => {
  getDispatch().then((dispatch) => {
    dispatch({ type: globalTypes.LOGOUT });
  });
};

export const setRedirect = (path) => {
  getDispatch().then((dispatch) => {
    dispatch({ type: types.SET_REDIRECT, payload: path });
  });
};
